import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardActions, CardContent, CardMedia, Typography, IconButton } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';

const CardComp = ( {article} ) => {
  const link = `/article/${article.id}`
  const backend = 'https://oureclecticsociety.org/core'

  return (
    <Card sx={{ maxWidth: 345, m: 1, minWidth: 250 }} >
      <CardMedia
        sx={{ height: 300 }}
        //image= {`http://localhost:8000${article.image}`}
        image={`https://res.cloudinary.com/dl0hql4ku/${article.image}`}
        title="green iguana"
      />
      <CardContent>
        <Typography className='article' fontWeight={500} gutterBottom variant="h5" component="div">
          {article.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {article.excerpt}...<Link to={link}><Typography>read more</Typography></Link>
        </Typography>
      </CardContent>
      <CardActions>
        <IconButton sx={{color:'grey'}} >
          <EditNoteIcon />
          <Typography>Comment</Typography>
        </IconButton>
        <IconButton sx={{color:'orange'}} >
          <InsertEmoticonIcon />
          <Typography>Like</Typography>
        </IconButton>
      </CardActions>
    </Card>
  )
}

export default CardComp

